module.exports = {"TXTWCL_Read_less":{"id":"TXTWCL_Read_less","defaultMessage":"縮小"},"TXTWCL_Read_more":{"id":"TXTWCL_Read_more","defaultMessage":"もっと読む"}}